module.exports = __webpack_public_path__ + "img/PDM-600-Mobile.977b8136.png";